import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import "../../styles/css/ElevationForm/elevationForm.css";

import { FilePond, File, registerPlugin } from "react-filepond";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";

registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateType
);

class SectionF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      attachmentf: "",
    };
    this.onUploadImage = this.onUploadImage.bind(this);
  }

  onUploadImage(e) {
    this.setState({
      attachmentf: e.target.value,
    });
  }

  render() {
    const { sectionF, onClickF, validateF } = this.props;

    return (
      <div className="form-wrapper-elevation">
        <h2>PROPERTY OWNER (OR OWNER'S REPRESENTATIVE) CERTIFICATION</h2>
        {sectionF.isSubmittedF === false ? (
          <div className="err-msg-content">
            Something went wrong. Please try again.
          </div>
        ) : null}
        <table>
          <tbody>
            <tr>
              <td colSpan="6">
                <div className="question-wrapper">
                  <p className="sub-question-title">
                    The property owner or owner's authorized representative who
                    completes Sections A, B, and E for Zone A (without a
                    FEMA-issued or community-issued BFE) or Zone AO must sign
                    here. The statements in Sections A, B, and E are correct to
                    the best of my knowledge.
                  </p>
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="6">
                <p className="sub-question-title">
                  Property Owner or Owner's Authorized Representative's Name
                </p>
                <div className="input-box-wrapper">
                  <input
                    type="text"
                    name="building_owner_name"
                    value={sectionF.building_owner_name}
                    onChange={onClickF}
                    className="form-input-box"
                  />
                  {/* {validateF.message(
                    "building_ownner_name",
                    sectionF.building_ownner_name,
                    "required",
                    { className: "error-msg-text" }
                  )} */}
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="6">
                <p className="sub-question-title">Address</p>

                <div className="input-box-wrapper">
                  <input
                    type="text"
                    value={sectionF.addressLine.text}
                    onChange={onClickF}
                    name="owner_address"
                    className="form-input-box"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="2">
                <p className="sub-question-title">City</p>
                <div className="input-box-wrapper">
                  <input
                    type="text"
                    value={sectionF.city}
                    onChange={onClickF}
                    name="owner_city"
                    className="form-input-box"
                  />
                </div>
              </td>
              <td colSpan="2">
                <p className="sub-question-title">State</p>

                <div className="input-box-wrapper">
                  <input
                    type="text"
                    value={sectionF.region}
                    onChange={onClickF}
                    name="owner_state"
                    className="form-input-box"
                  />
                </div>
              </td>
              <td colSpan="2">
                <p className="sub-question-title">ZIP Code</p>

                <div className="input-box-wrapper">
                  <input
                    type="text"
                    value={sectionF.zipcode}
                    onChange={onClickF}
                    name="owner_zipcode"
                    className="form-input-box"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="3">
                <p className="sub-question-title">Signature</p>

                <div className="input-box-wrapper">
                  <input
                    disabled
                    type="text"
                    value={sectionF.owner_signature}
                    onChange={onClickF}
                    name="owner_signature"
                    className="form-input-box"
                  />
                </div>
              </td>
              <td>
                <p className="sub-question-title">Date</p>

                <div className="input-box-wrapper">
                  <input
                    type="text"
                    name="owner_sign_date"
                    value={sectionF.owner_sign_date}
                    onChange={onClickF}
                    className="form-input-box"
                  />
                </div>
              </td>
              <td colSpan="2">
                <p className="sub-question-title">Telephone</p>

                <div className="input-box-wrapper">
                  <input
                    type="text"
                    name="owner_telephone"
                    value={sectionF.owner_telephone}
                    onChange={onClickF}
                    className="form-input-box"
                  />
                  {validateF.message(
                    "phone|number",
                    sectionF.owner_telephone,
                    "numeric",
                    { className: "error-msg-text" }
                  )}
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="6">
                <p className="sub-question-title">Comments</p>
                <div className="input-box-wrapper">
                  <textarea
                    name="owner_comments"
                    value={sectionF.owner_comments}
                    onChange={onClickF}
                    cols="50"
                    rows="10"
                    maxLength="1000"
                    className="form-input-textarea"
                  ></textarea>
                </div>

                <div className="check-label-note">
                  <input
                    type="checkbox"
                    value="open"
                    name="attachmentf"
                    onChange={this.onUploadImage}
                    className="checkbox-icon-btn"
                  />
                  <label className="qst-type">Check here if attachments</label>
                </div>
                {this.state.attachmentf === "open" ? (
                  <div>
                    <FilePond
                      acceptedFileTypes={[
                        "application/pdf",
                        "image/png",
                        "image/jpeg",
                      ]}
                      ref={(ref) => (this.pond = ref)}
                      files={sectionF.property_attachment}
                      allowMultiple={true}
                      maxFiles={5}
                      name="files"
                      labelIdle="Click here or drop your files here"
                      onupdatefiles={(fileItems) => {
                        this.props.imagedata(fileItems);
                      }}
                    ></FilePond>
                  </div>
                ) : null}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default SectionF;



// WEBPACK FOOTER //
// ./src/pages/ElevationForm/SectionF.js